class VideoWithBenefitsPlayer extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._initVideo();
    this._initSwiper();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  _initVideo() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.video.muted = true;
    this.video.loop = true;
    this.video.playsInline = true;
    this.video.setAttribute('muted', '');
    this.video.setAttribute('loop', '');
    this.video.setAttribute('playsinline', '');

    this.hasStarted = false;
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._startPlayback();
          this.observer.disconnect();
        });
      },
      { threshold: 0.2 }
    );

    this.observer.observe(this.video);
  }

  _startPlayback() {
    if (this.hasStarted || !this.video) return;
    this.hasStarted = true;

    const playPromise = this.video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  _initSwiper() {
    const section = this.closest('[data-video-with-benefits]');
    const swiperEl =
      section && section.querySelector('.video-with-benefits__swiper');
    if (!swiperEl) return;

    const create = () => {
      if (typeof Swiper === 'undefined') return;
      new Swiper(swiperEl, {
        direction: 'vertical',
        loop: true,
        allowTouchMove: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        autoplay: {
          delay: 1000
        },
        breakpoints: {
          1024: {
            init: false
          }
        }
      });
    };

    if (typeof Swiper !== 'undefined') {
      requestAnimationFrame(create);
    } else if (document.readyState === 'complete') {
      requestAnimationFrame(create);
    } else {
      window.addEventListener('load', () => requestAnimationFrame(create), {
        once: true
      });
    }
  }
}

if (!customElements.get('video-with-benefits-player')) {
  customElements.define('video-with-benefits-player', VideoWithBenefitsPlayer);
}
